export function fogIndex(x, y, width) {
    return y * width + x;
}
export function getFogAt(grid, x, y) {
    return grid.cells[fogIndex(x, y, grid.width)] ?? 'hidden';
}
//# sourceMappingURL=fog.js.map